import script from "./PuzzleDropdowns.vue?vue&type=script&setup=true&lang=ts"
export * from "./PuzzleDropdowns.vue?vue&type=script&setup=true&lang=ts"

import "./PuzzleDropdowns.vue?vue&type=style&index=0&id=eec4656e&scoped=true&lang=scss"

import exportComponent from "D:\\wamp\\www\\GSALT\\gsalt-matters-ibd-denmark\\web\\modules\\vuejs\\vuejs-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eec4656e"]])

export default __exports__